/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Cps_LabelInputs */

const en_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters Per Second`)
};

const fr_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres par seconde`)
};

const de_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen pro Sekunde`)
};

const it_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri al secondo`)
};

const ru_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Символов в секунду`)
};

const es_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres por segundo`)
};

const zh_cn2_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每秒字符数`)
};

const ja_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1秒あたりの文字数`)
};

const hi_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्ण प्रति सेकंड`)
};

const pt_pt2_style_guide_manager_cps_label = /** @type {(inputs: Style_Guide_Manager_Cps_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres por segundo`)
};

/**
* | output |
* | --- |
* | "Characters Per Second" |
*
* @param {Style_Guide_Manager_Cps_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_cps_label = /** @type {((inputs?: Style_Guide_Manager_Cps_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Cps_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_cps_label(inputs)
	if (locale === "de") return de_style_guide_manager_cps_label(inputs)
	if (locale === "it") return it_style_guide_manager_cps_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_cps_label(inputs)
	if (locale === "es") return es_style_guide_manager_cps_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_cps_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_cps_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_cps_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_cps_label(inputs)
	return en_style_guide_manager_cps_label(inputs)
});